<template>
  <div
    class="customer-chat-view tw-w-screen tw-h-screen md:tw-py-4 tw-bg-gray-300 tw-flex tw-justify-center tw-items-center"
  >
    <CustomerChat :modal="true" />
  </div>
</template>

<script>
import { mapGetters } from "vuex";
export default {
  name: "CustomerChatView",
  components: {
    CustomerChat: () => import("@/ui/components/customerChat/CustomerChat.vue"),
  },
  data() {
    return {
      modal: true,
    };
  },
  computed: {},
};
</script>

<style>

</style>
